import React from "react";
import { createIcon } from "@chakra-ui/icons";

export const KRFlag = createIcon({
  displayName: "KRFlag",
  viewBox: "0 0 96 64",
  defaultProps: {
    role: "img"
  },
  path: (
    <>
      <title> Korea flag </title>
      <path d="M0 0H96V64H0V0Z" fill="white" />
      <path
        d="M26.7574 37.6587L34.5284 48.9735L32.5805 50.2367L24.8197 38.9185L26.7574 37.6587Z"
        fill="#1D1D1B"
      />
      <path
        d="M28.0571 45.6778L31.6168 50.857L29.6689 52.1201L26.1092 46.9276L28.0571 45.6778Z"
        fill="#1D1D1B"
      />
      <path
        d="M23.8455 39.5416L27.4053 44.7308L25.4711 45.9939L21.9079 40.8014L23.8455 39.5416Z"
        fill="#1D1D1B"
      />
      <path
        d="M20.9342 41.4354L28.7052 52.7502L26.7573 54.0001L19 42.6852L20.9342 41.4354Z"
        fill="#1D1D1B"
      />
      <path
        d="M69.4604 10L73.0201 15.1792L71.0722 16.4423L67.5125 11.2498L69.4604 10Z"
        fill="#1D1D1B"
      />
      <path
        d="M63.6372 13.7626L67.1867 18.9551L65.2491 20.2149L61.6893 15.0257L63.6372 13.7626Z"
        fill="#1D1D1B"
      />
      <path
        d="M73.6581 16.1255L77.2178 21.3147L75.2802 22.5679L71.7205 17.3887L73.6581 16.1255Z"
        fill="#1D1D1B"
      />
      <path
        d="M66.5491 11.8829L74.3064 23.1978L72.3722 24.461L64.6012 13.1427L66.5491 11.8829Z"
        fill="#1D1D1B"
      />
      <path
        d="M67.8349 19.9021L71.398 25.0813L69.4604 26.3411L65.9007 21.1519L67.8349 19.9021Z"
        fill="#1D1D1B"
      />
      <path
        d="M73.0201 48.8207L69.4604 53.9999L67.5125 52.7501L71.0722 47.5609L73.0201 48.8207Z"
        fill="#1D1D1B"
      />
      <path
        d="M68.1609 45.6778L70.1088 46.9276L66.5491 52.1201L64.6012 50.857L68.1609 45.6778Z"
        fill="#1D1D1B"
      />
      <path
        d="M65.2491 43.7851L67.1867 45.0482L63.6372 50.2374L61.6893 48.9743L65.2491 43.7851Z"
        fill="#1D1D1B"
      />
      <path
        d="M75.2802 41.4354L77.2178 42.6852L73.6581 47.8743L71.7205 46.6145L75.2802 41.4354Z"
        fill="#1D1D1B"
      />
      <path
        d="M72.3718 39.5416L74.306 40.8014L70.7463 45.9939L68.8087 44.7308L72.3718 39.5416Z"
        fill="#1D1D1B"
      />
      <path
        d="M71.398 38.9185L67.8349 44.0977L65.9007 42.8479L69.4604 37.6587L71.398 38.9185Z"
        fill="#1D1D1B"
      />
      <path
        d="M34.5284 15.0257L26.7574 26.3406L24.8197 25.0808L32.5805 13.7626L34.5284 15.0257Z"
        fill="#1D1D1B"
      />
      <path
        d="M31.6166 13.1427L23.8455 24.461L21.9079 23.1978L29.6687 11.8829L31.6166 13.1427Z"
        fill="#1D1D1B"
      />
      <path
        d="M28.7052 11.2498L20.9342 22.568L19 21.3149L26.7573 10L28.7052 11.2498Z"
        fill="#1D1D1B"
      />
      <path
        d="M60.4515 38.0885C60.3555 38.6118 60.04 39.0351 59.7485 39.4583C57.4096 42.8278 54.162 44.8608 50.0295 45.4274C42.67 46.4339 35.9312 41.748 34.4189 34.6124C33.805 31.7162 34.1994 28.9167 35.4785 26.2337C35.4888 26.2104 35.5094 26.1904 35.5266 26.1704C35.6089 26.1504 35.6432 26.2037 35.6706 26.2637C35.7117 26.427 35.6466 26.577 35.6157 26.7303C34.7446 30.7497 37.4539 34.3291 41.3531 34.8291C44.0864 35.1823 46.3189 34.2025 47.9513 32.0228C48.452 31.3529 49.0007 30.7397 49.6832 30.2464C52.5124 28.1968 56.4014 28.4734 58.8912 30.8997C60.7328 32.6961 61.2917 34.8557 60.8013 37.3087C60.7739 37.452 60.7053 37.582 60.6607 37.7219C60.5956 37.8486 60.5579 37.9886 60.4515 38.0885Z"
        fill="#00479F"
      />
      <path
        d="M60.5958 37.7454C60.9902 36.2623 61.0142 34.7825 60.414 33.3461C59.3886 30.8865 57.5059 29.39 54.8035 29.0534C52.0737 28.7135 49.8171 29.6867 48.2087 31.8763C47.0016 33.5227 45.4549 34.5725 43.3973 34.9325C39.7689 35.5691 36.0103 32.9795 35.441 29.4334C35.2661 28.3569 35.3313 27.3004 35.6194 26.2539C35.6468 26.1439 35.5953 26.0206 35.6777 25.9206C37.1386 23.0177 39.4157 20.9147 42.4439 19.6249C48.73 16.952 55.8255 18.8884 59.6355 24.4175C62.5231 28.6102 62.8077 33.1028 60.7398 37.7321C60.7227 37.7687 60.6952 37.7987 60.6712 37.832C60.6026 37.842 60.5546 37.8287 60.5958 37.7454Z"
        fill="#CC2E3A"
      />
      <path
        d="M0 0V-1H-1V0H0ZM96 0H97V-1H96V0ZM96 64V65H97V64H96ZM0 64H-1V65H0V64ZM0 1H96V-1H0V1ZM95 0V64H97V0H95ZM96 63H0V65H96V63ZM1 64V0H-1V64H1Z"
        fill="#767676"
      />
    </>
  )
});
